// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3Zoj1","cell":"ColumnAccessor_cell__3vxoL","firstCellAccent":"ColumnAccessor_firstCellAccent__13ZY6"};